var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1.667 4.333 28.667 23.333"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.667,
    height: 21.333,
    x: 2.667,
    y: 5.333,
    stroke: "#B8EEFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 2.667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B8EEFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29.333 9.333-11.96 7.6a2.49 2.49 0 0 1-2.746 0l-11.96-7.6"
  })));
};
export default SvgMail;